var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMarketShare = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "240px",
    height: "192px",
    viewBox: "0 0 240 192",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MarketShare_Static") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MarketShare_Static"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle1",
    fill: "#FFFFFF",
    x: 5,
    y: 6,
    width: 230,
    height: 180
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_Static",
    fill: "#D9E8F6",
    stroke: "#D9E8F6",
    strokeWidth: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,6 C10.4771525,6 6,10.4771525 6,16 L6,176 C6,181.522847 10.4771525,186 16,186 L224,186 C229.522847,186 234,181.522847 234,176 L234,16 C234,10.4771525 229.522847,6 224,6 L16,6 Z M9,10 L231,10 L231,182 L9,182 L9,10 Z",
    id: "Combined-Shape1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(52.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69,0 C102.137085,0 129,26.862915 129,60 L69,60 L69,0 Z",
    id: "Combined-Shape2",
    fill: "#4B76B8"
  }), /*#__PURE__*/React.createElement("text", {
    id: "$",
    fontFamily: "SourceSansPro-Bold, Source Sans Pro",
    fontSize: 32,
    fontWeight: "bold",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 85.552,
    y: 47
  }, "$")), /*#__PURE__*/React.createElement("path", {
    d: "M60,12 L60,72 L60.4695167,72 L102.66052,114.191003 C91.7846723,125.187121 76.6879527,132 60,132 C26.862915,132 0,105.137085 0,72 C0,38.862915 26.862915,12 60,12 Z",
    id: "Combined-Shape3",
    fill: "#1A4480"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2167748,72 L137,72 C137,88.6236737 130.239504,103.668349 119.317882,114.534657 L77,72.2167748 L77.2167748,72 Z",
    id: "Combined-Shape4",
    fill: "#1A4480"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMarketShare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MarketShare.586c02b16088890ce6f55ac1e6854af9.svg";